__turbopack_context__.v({
  "ButtonContainer": "_06o8Sq_ButtonContainer",
  "ButtonContainerRichText": "_06o8Sq_ButtonContainerRichText",
  "Content": "_06o8Sq_Content",
  "ImageContainer": "_06o8Sq_ImageContainer",
  "ImageVisible": "_06o8Sq_ImageVisible",
  "IsFromRichText": "_06o8Sq_IsFromRichText",
  "LastUpdated": "_06o8Sq_LastUpdated",
  "RichText": "_06o8Sq_RichText",
  "Text": "_06o8Sq_Text",
  "Title": "_06o8Sq_Title",
  "TitleBottom": "_06o8Sq_TitleBottom",
  "TitleContainer": "_06o8Sq_TitleContainer",
  "TitleDesktop": "_06o8Sq_TitleDesktop",
  "TitleMobile": "_06o8Sq_TitleMobile",
  "TitleTop": "_06o8Sq_TitleTop",
  "Visible": "_06o8Sq_Visible",
});
